import React from 'react';
import { Loader2 } from 'lucide-react';

interface SearchLoaderProps {
  /** Optional label below the icon (e.g. "Laster...") */
  text?: string;
  /** If true, centers in viewport for full-page loading */
  fullPage?: boolean;
}

export const SearchLoader = ({ text, fullPage }: SearchLoaderProps = {}) => {
  return (
    <div className={`flex flex-col items-center justify-center p-4 ${fullPage ? 'min-h-[40vh]' : ''}`}>
      <Loader2 className="h-9 w-9 animate-spin text-purple-600" aria-hidden />
      {text && <p className="mt-2 text-sm text-gray-600">{text}</p>}
    </div>
  );
};

export default SearchLoader;
